"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Popover = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Popover"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); } /* eslint-disable class-methods-use-this */
var styles = {
  "anypoint-styles": "styles__anypoint-styles__2Oi68",
  "nav-item-wrapper": "styles__nav-item-wrapper__3UkI7",
  "item": "styles__item__3G9OQ",
  "nav-content": "styles__nav-content__3Rts4",
  "open": "styles__open__36W4w",
  "popIn": "styles__popIn__3Jtkb",
  "anypointStyles": "styles__anypoint-styles__2Oi68",
  "navItemWrapper": "styles__nav-item-wrapper__3UkI7",
  "navContent": "styles__nav-content__3Rts4"
}; 
require('./styles.css');
var popoverStyles = {
  "anypoint-styles": "popoverStyles__anypoint-styles__xbQso",
  "popover-content": "popoverStyles__popover-content__2d8xM",
  "anypointStyles": "popoverStyles__anypoint-styles__xbQso",
  "popoverContent": "popoverStyles__popover-content__2d8xM"
}; 
require('./popoverStyles.css');
var displayName = 'NavDropdown';
var propTypes = {
  /** Contents of the dropdown */
  children: _propTypes["default"].node,
  /** Text or Custom Component to display in the NavItem */
  content: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].element]),
  /** Trigger function when open called */
  onOpen: _propTypes["default"].func,
  /** Trigger function when close called */
  onClose: _propTypes["default"].func,
  /** className applied to nav item */
  className: _propTypes["default"].string,
  /** data-test-id for the root popover */
  testId: _propTypes["default"].string
};
var defaultProps = {
  children: null,
  content: 'dummy content',
  onOpen: null,
  onClose: null,
  className: '',
  testId: null
};
var NavDropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(NavDropdown, _React$Component);
  var _super = _createSuper(NavDropdown);
  function NavDropdown(props, context) {
    var _this;
    _classCallCheck(this, NavDropdown);
    _this = _super.call(this, props, context);
    _this.handleOpen = _this.handleOpen.bind(_assertThisInitialized(_this));
    _this.handleClose = _this.handleClose.bind(_assertThisInitialized(_this));
    _this.handleKeyboardNavigation = _this.handleKeyboardNavigation.bind(_assertThisInitialized(_this));
    _this.handleFocusButton = _this.handleFocusButton.bind(_assertThisInitialized(_this));
    _this.state = {
      open: false
    };
    return _this;
  }
  _createClass(NavDropdown, [{
    key: "handleKeyboardNavigation",
    value: function handleKeyboardNavigation(event) {
      var open = this.state.open;
      // Escape
      if (open && event.keyCode === 27) {
        event.preventDefault();
        this.handleClose();
      }
      // Enter
      if (!open && event.keyCode === 13) {
        event.preventDefault();
        this.handleOpen();
      }
    }
  }, {
    key: "handleFocusButton",
    value: function handleFocusButton() {
      var testId = this.props.testId;
      var selector = "[data-test-id=\"".concat(testId, "-trigger-wrap\"]");
      var dropdownButton = document.querySelector(selector);
      if (dropdownButton) {
        dropdownButton.focus();
      }
    }
  }, {
    key: "focusOnOpen",
    value: function focusOnOpen() {
      setTimeout(function () {
        var popoverContent = document.querySelector('[data-test-id="navbar-dropdown"]');
        if (popoverContent) {
          popoverContent.focus();
        }
      }, 300);
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      this.setState({
        open: true
      });
      var onOpen = this.props.onOpen;
      this.focusOnOpen();
      if (onOpen) {
        onOpen();
      }
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      this.setState({
        open: false
      });
      var onClose = this.props.onClose;
      if (onClose) {
        onClose();
      }
      this.handleFocusButton();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        content = _this$props.content,
        className = _this$props.className,
        testId = _this$props.testId,
        children = _this$props.children;
      var NavItemContent;
      var isReactComponent = content.type;
      if (typeof content === 'string') {
        NavItemContent = /*#__PURE__*/_react["default"].createElement("span", {
          className: "NavItem-text"
        }, content);
      } else if (isReactComponent) {
        NavItemContent = content;
      }
      var NavItem = /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(styles.navContent, " ").concat(this.state.open ? styles.open : ''),
        "data-test-id": "navbar-dropdown",
        onKeyDown: this.handleKeyboardNavigation,
        tabIndex: "0"
      }, NavItemContent);
      return /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
        anchorPosition: "tc",
        className: "".concat(styles.navItemWrapper, " ").concat(className),
        closeOnClickInside: true,
        content: NavItem,
        isFixed: true,
        onClose: this.handleClose,
        onOpen: this.handleOpen,
        onFocus: this.handleFocusButton,
        popupPosition: "bc",
        theme: popoverStyles,
        triggerOn: ['click'],
        testId: testId
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: styles.item,
        "data-test-id": "".concat(testId, "-dropdown"),
        onKeyPress: this.handleKeyboardNavigation
      }, children));
    }
  }]);
  return NavDropdown;
}(_react["default"].Component);
NavDropdown.displayName = displayName;
NavDropdown.propTypes = propTypes;
NavDropdown.defaultProps = defaultProps;
var _default = exports["default"] = NavDropdown;
//# sourceMappingURL=NavDropdown.js.map